import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { ADMIN } from '@/constants/testIds';
import { Storefront } from '@phosphor-icons/react';

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email.trim(), password);
      if (u.role !== 'admin') {
        toast.error('Not an admin account');
      } else {
        toast.success('Welcome back!');
        navigate('/admin/dashboard');
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-cream-100 bg-grain px-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-stone-200 p-7 shadow-sm">
        <div className="flex items-center gap-2 mb-6">
          <span className="w-10 h-10 rounded-2xl bg-terracotta-600 text-white grid place-items-center font-bold font-heading">Z</span>
          <div>
            <p className="font-heading text-xl text-stone-900">MyZippyKart</p>
            <p className="text-xs text-stone-500">Admin Panel</p>
          </div>
        </div>
        <h1 className="font-heading text-2xl text-stone-900">Sign in</h1>
        <p className="text-sm text-stone-500 mt-1">Admin access only.</p>

        <form onSubmit={submit} className="mt-6 space-y-3">
          <div>
            <label className="text-xs font-medium text-stone-600">Email</label>
            <input data-testid={ADMIN.loginEmail} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full h-11 px-4 mt-1 rounded-xl bg-white border border-stone-200 focus:border-olive-400 focus:outline-none text-sm"/>
          </div>
          <div>
            <label className="text-xs font-medium text-stone-600">Password</label>
            <input data-testid={ADMIN.loginPassword} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full h-11 px-4 mt-1 rounded-xl bg-white border border-stone-200 focus:border-olive-400 focus:outline-none text-sm"/>
          </div>
          <button data-testid={ADMIN.loginBtn} disabled={busy} type="submit" className="w-full h-12 rounded-full bg-terracotta-600 text-white font-semibold hover:bg-terracotta-700 disabled:bg-stone-300">{busy ? 'Signing in…' : 'Sign In'}</button>
        </form>

        <a href="/" className="inline-flex items-center gap-1.5 mt-6 text-xs text-olive-800 hover:text-olive-900"><Storefront size={14}/> Back to store</a>
      </div>
    </div>
  );
}
